<template>
  <main id="help-dashboard" class="site-main">
    <div class="grid-container">
      <div class="grid-x grid-padding-x">
        <div class="cell">
          <article>
            <h1>Connecting PayPal for Payouts</h1>

            <div class="grid-x grid-padding-x">
              <div class="cell large-auto small-order-2 large-order-1">
                <div class="panel">
                  <section class="help-section">
                    <h2 class="help-section__title">1. Ensure your PayPal account is set up for
                      business.</h2>

                    <div class="help-section__details">
                      <p>Without your PayPal being set up for business you will not have the ability
                        to enable payouts for PayPal.</p>

                      <p>If you are not already set up for business you will need to start the
                        business setup and provide your legal business details.</p>
                    </div>

                    <div class="help-section__photo">
                      <img src="../../../assets/img/help/connecting-paypal-for-payouts_1.jpg"
                           alt="PayPal: Tools > Business Setup">
                    </div>
                  </section>

                  <section class="help-section">
                    <h2 class="help-section__title">2. Login into PayPal developer.</h2>

                    <div class="help-section__details">
                      <p>To authenticate your PayPal account with the Vendor Consignment app you
                        will need to create a developer app by logging into
                        <a href="https://developer.paypal.com/" target="_blank">
                          https://developer.paypal.com/</a>.</p>
                    </div>

                    <div class="help-section__photo">
                      <img src="../../../assets/img/help/paypal-1.png"
                           alt="PayPal: Log into developer dashboard">
                    </div>
                  </section>

                  <section class="help-section">
                    <h2 class="help-section__title">3. Create a live app.</h2>

                    <div class="help-section__details">
                      <p>To make live payments you will need to use credentials from a "live" app in
                        PayPal.</p>

                      <p>If you want to make test payouts you can enter "sandbox" credentials in our
                        app.</p>
<!--                      <p>If you want to make test payouts you can enter "sandbox" credentials in our-->
<!--                        app. A tutorial on how to perform these tests can be located in our-->
<!--                        "<a href="" target="_blank">How to Test PayPal Payouts</a>" tutorial.</p>-->

                      <p>After clicking the "live" tab you will need to create a new app. It will
                        prompt you to name your app. You can name this whatever you want.</p>
                    </div>

                    <div class="help-section__photo">
                      <img src="../../../assets/img/help/paypal-2.png"
                           alt="PayPal: App credentials">
                    </div>

                    <div class="help-section__photo">
                      <img src="../../../assets/img/help/paypal-3.png"
                           alt="PayPal: Create app">
                    </div>
                  </section>

                  <section class="help-section">
                    <h2 class="help-section__title">4. Save your PayPal API credentials.</h2>

                    <div class="help-section__details">
                      <p>Copy and paste the api key and api secret and paste them into our PayPal
                        configuration page within our app.</p>

                      <p>After adding the api key and api secret to our app it will display "Valid"
                        if the credentials are correct. If they show invalid and you know the keys
                        are correct, you may need to start over by creating a new app in PayPal.</p>
                    </div>

                    <div class="help-section__photo">
                      <img src="../../../assets/img/help/paypal-4.png"
                           alt="PayPal: Client ID and Secret">
                    </div>
                  </section>

                  <section class="help-section">
                    <h2 class="help-section__title">5. Enable Payouts for your PayPal account.</h2>

                    <div class="help-section__details">
                      <p>Before you can perform a payout in our app, "payouts" will need to be
                        enabled on your PayPal account.</p>

                      <p>Visit the "account eligibility" page and scroll down to the permissions
                        table. If the "live" column for "Payouts" does not show enabled, you will
                        need to enable this.</p>

                      <p>It will ask you for a reason as to why you need it enabled. You can give
                        any reason you want, but you can copy the example reason below as well. This
                        will usually be approved within 1-3 days.</p>

                      <p><i><strong>Example Reason to Enable Payouts</strong><br>To perform payouts
                        to my vendors through a third party system.</i></p>
                    </div>

                    <div class="help-section__photo">
                      <img src="../../../assets/img/help/paypal-5.png"
                           alt="PayPal: Account eligibility">
                    </div>

                    <div class="help-section__photo">
                      <img src="../../../assets/img/help/paypal-6.png"
                           alt="PayPal: Enable Payouts">
                    </div>
                  </section>

                  <section class="help-section">
                    <h2 class="help-section__title">6. Run a Payout</h2>

                    <div class="help-section__details">
                      <p>Congratulations! You should now be all set to run payouts through PayPal.</p>
                    </div>
                  </section>
                </div>
              </div>

              <div class="cell large-shrink small-order-1 large-order-2"
                   data-sticky-container>
                <div class="sidebar sticky" data-sticky data-margin-top="0"
                     style="min-width: 350px;"
                     v-sticky>
                  <div class="panel">
                    <div class="panel__header">
                      <h2>Table of Contents</h2>
                    </div>

                    <div class="panel__content">
                      <ol>
                        <li>Ensure your PayPal account is set up for business.</li>
                        <li>Login into PayPal developer.</li>
                        <li>Create a live app.</li>
                        <li>Save your PayPal API credentials.</li>
                        <li>Enable Payouts for your PayPal account.</li>
                        <li>Run a Payout.</li>
                      </ol>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </article>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
global.jQuery = require('jquery')
let $ = global.jQuery
window.$ = $

export default {
  name: 'connectingPaypal',
  components: {},
  created () {

  },
  directives: {
    sticky: function (el) {
      // eslint-disable-next-line
      new Foundation.Sticky($(el))
    },
    unbind: function (el) {
      $(el).foundation.destroy()
    }
  }
}
</script>

<style lang="scss">
@import '../../../styles/variables';
@import '../../../styles/mixins';

.help-section {
  margin-bottom: 45px;

  &__title {
    font-size: 18px;
  }

  &__details {
    margin-bottom: 15px;
    padding-left: 15px;
  }

  &__photo {
    margin-bottom: 15px;
    padding-left: 15px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  &:last-child {
    margin-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/help/articles/connecting-paypal.vue